import { render, staticRenderFns } from "./person-manager-new.vue?vue&type=template&id=0f4aa8b7&scoped=true"
import script from "./person-manager-new.vue?vue&type=script&lang=js"
export * from "./person-manager-new.vue?vue&type=script&lang=js"
import style0 from "./person-manager-new.vue?vue&type=style&index=0&id=0f4aa8b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../CrossD.Portal.Vue/ClientApp/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4aa8b7",
  null
  
)

export default component.exports